import st from "@/styles/Page404.module.scss"
import {useTranslation} from "react-i18next";
import ChevroneBtn from "@/ui/ChevroneBtn.tsx";
import {useNavigate} from "react-router-dom";

const Page404 = () => {
    
    const {t}= useTranslation()
    const navigation = useNavigate()
    
    return (
        <main className={st.main}>
            
            <strong className={st.text_404}>
                404
            </strong>
            
            <span className={st.wrong_text}>
                {t("unexistent_page")}
            </span>
            
            <ChevroneBtn
                onClick={() => {
                    navigation(-1)
                }}
                direction={"left"}
            />
        
        </main>
    )
}

export default Page404